import { useEffect, useState } from 'react'

/** Un minuto: suficiente para que un meet deje de estar en curso sin que se note el retraso. */
const INTERVALO_DEFECTO_MS = 60_000

/**
 * La hora actual, refrescada sola.
 *
 * `useMemo(() => new Date(), [])` congela el reloj en el momento del montaje. En una pantalla que
 * vive toda la sesión —el layout autenticado— eso significa que pasada la medianoche se sigue
 * mostrando el día anterior, que un meet terminado nunca desaparece y que uno que todavía no
 * empezaba nunca aparece.
 */
export function useAhora(intervaloMs: number = INTERVALO_DEFECTO_MS): Date {
  const [ahora, setAhora] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setAhora(new Date()), intervaloMs)
    return () => clearInterval(id)
  }, [intervaloMs])

  return ahora
}
